import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonGroup,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Badge
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Workbook from 'react-excel-workbook';
import Loader from '../../Loader';
import StudentPage from '../../views/StudentPage';
const GLOBAL = require('../../Globals');
const txtupper = {

	textTransform: 'uppercase',
	fontSize: '20px'
}

class StudentReport extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			accyear: [],
			acyear: '',
			stdate: '',
			endate: '',
			_message: '',
			alertClass: '',
			posts: [],
			clas: [],
			sect: [],
			reli: [],
			desti: [],
			communi: [],
			vehic: [],
			viewtab: 0,
			_redirect: false,
			collapse: false,
			currentPage: 1,
			todosPerPage: 3,
			classs: [],
			fields: [],
			cl: [],
			se: [],
			com: [],
			rel: [],
			vehi: [],
			gen: [],
			typ: [],
			tran: [],
			jyear: [],
			postFilter: [],
			route: [],
			dropdownOpen: new Array(2).fill(false),
			collapse: false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleClassChange = this.handleClassChange.bind(this);
		this.handleSecChange = this.handleSecChange.bind(this);
		this.handleCommuniChange = this.handleCommuniChange.bind(this);
		this.handleRelChange = this.handleRelChange.bind(this);
		this.handleTransChange = this.handleTransChange.bind(this);
		this.handleVehicleChange = this.handleVehicleChange.bind(this);
		this.handleGenderChange = this.handleGenderChange.bind(this);
		this.handleTypeChange = this.handleTypeChange.bind(this);
		this.handleFieldChange = this.handleFieldChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.onViewClick = this.onViewClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggleCollapse = this.toggleCollapse.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}

	toggleCollapse() {

		this.setState({ viewtab: 0 });
		this.setState({ collapse: !this.state.collapse });
	}

	onAddFields(e) {

		if (e.target.checked) {

			this.setState({ [e.target.name]: true });
		}
		else {

			this.setState({ [e.target.name]: false });
		}
	}

	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
			dropdownOpen: newArray
		});
	}

	printDocument() {
		$("#hide_div").show();
		var content = document.getElementById("print-report");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	handleFieldChange(value) {

		this.setState({ fields: value });
		// this.filterdata();
	}

	/** set Class value to react select **/
	handleClassChange(value) {

		this.state.cl = [];

		let clsall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				clsall = 1;
			}
		})
		let clss = [];
		if (clsall == 1) {
			this.state.clas.map(function (e, key) {
				clss.push(e.id);
			});
			this.state.cl = clss;
		}
		else {

			{
				value.map(item =>

					this.state.cl.push(item.value)
				)
			}
		}

		this.setState({ classs: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Section value to react select **/
	handleSecChange(value) {

		this.state.se = [];
		let secall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				secall = 1;
			}
		})

		let secs = [];
		if (secall == 1) {
			this.state.sect.map(function (e, key) {
				secs.push(e.id);
			});
			this.state.se = secs;
		}
		else {
			{
				value.map(item =>

					this.state.se.push(item.value)
				)
			}
		}

		this.setState({ section: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Community value to react select **/
	handleCommuniChange(value) {

		this.state.com = [];
		let comall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				comall = 1;
			}
		})

		let com = [];
		if (comall == 1) {
			this.state.communi.map(function (e, key) {
				com.push(e.id);
			});
			this.state.com = com;
		}
		else {
			{
				value.map(item =>

					this.state.com.push(item.value)
				)
			}
		}
		this.setState({ community: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Religion value to react select **/
	handleRelChange(value) {

		this.state.rel = [];

		let relall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				relall = 1;
			}
		})

		let rel = [];
		if (relall == 1) {
			this.state.reli.map(function (e, key) {
				rel.push(e.id);
			});
			this.state.rel = rel;
		}
		else {
			{
				value.map(item =>

					this.state.rel.push(item.value)
				)
			}
		}
		this.setState({ religion: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Destination value to react select **/
	handleTransChange(value) {

		this.state.tran = [];
		let rall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				rall = 1;
			}
		})

		let trans = [];
		if (rall == 1) {
			this.state.trans.map(function (e, key) {
				trans.push(e.id);
			});
			this.state.tran = trans;
		}
		else {
			{
				value.map(item =>

					this.state.tran.push(item.value)
				)
			}
		}
		this.setState({ transport: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Vehicle value to react select **/
	handleVehicleChange(value) {

		this.state.vehi = [];
		let vall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				vall = 1;
			}
		})

		let vehi = [];
		if (vall == 1) {
			this.state.vehic.map(function (e, key) {
				vehi.push(e.id);
			});
			this.state.vehi = vehi;
		}
		else {
			{
				value.map(item =>

					this.state.vehi.push(item.value)
				)
			}
		}
		this.setState({ vehicle: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Gender value to react select **/
	handleGenderChange(value) {

		this.state.gen = [];
		let genall = 0;
		value.filter(function (obj) {
			if (obj.value == 'all') {
				genall = 1;
			}
		})

		let gen = [];
		if (genall == 1) {

			this.gend = [
				{ value: 'all', name: 'All' },
				{ value: 'Male', name: 'Male' },
				{ value: 'Female', name: 'Female' }
			];
			this.gend.map(function (e, key) {
				gen.push(e.value);
			});
			this.state.gen = gen;
		}
		else {
			{
				value.map(item =>

					this.state.gen.push(item.value)
				)
			}
		}
		this.setState({ gender: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}

	/** set Type value to react select **/
	handleTypeChange(value) {

		this.state.typ = [];
		{
			value.map(item =>

				this.state.typ.push(item.value)
			)
		}
		this.setState({ type: value });
		this.setState({ viewtab: 0 });
		this.filterdata();
	}



	onViewClick(e) {
		$("#showLoader").show();
		this.setState({ collapse: false });
		this.setState({ viewtab: 1 });
		$("#showLoader").hide();
		this.filterdata();
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.getdata();
	}

	onDateChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.setState({ viewtab: 0 });
		this.filterdata();

	}

	onSubmit(e) {
		e.preventDefault();

		if (this.state.stdcat) {

			PostData('student/addcat', this.state).then((result) => {
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Category Added Successfully!..',
						alertClass: 'alert alert-success',
					});
					document.getElementById("stcatform").reset();
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Already Added',
						alertClass: 'alert alert-danger'
					});
				}
			});

		}

	}

	handleClick(dd) {

		this.state.id = dd;
		if (window.confirm("Do you want to Delete?")) {
			PostData('student/deletecategory', this.state).then((result) => {
				let responseJson = result;

				if (responseJson.status == '1') {
					this.setState({
						_message: 'Student Category Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove Student Category',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getacyear();
		this.getclass();
		this.getsection();
		this.getcommunity();
		this.getreligion();
		this.getdestination();
		this.getvehicle();
		this.getroute();
	}

	/** get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getclass();
				this.getdata();
			}
		});
	}

	getdata() {
		this.setState({ posts: [] });
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getstdreportbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson,
					postFilter: responseJson
				});
				$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}

	getroute() {

		GetData('transport/getroute').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					route: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					clas: responseJson
				});
			}
		});
	}

	/** get Section **/
	getsection() {
		$("#showLoader").show();
		GetData('section/getsection').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sect: responseJson
				});
			}
		});
	}

	/** get Community **/
	getcommunity() {
		$("#showLoader").show();
		GetData('caste/getcommunity').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					communi: responseJson
				});
			}
		});
	}

	/** get Religion **/
	getreligion() {

		GetData('caste/getreligion').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					reli: responseJson
				});
			}
		});
	}

	/** get Destination **/
	getdestination() {

		GetData('transport/gettransplace').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					desti: responseJson
				});
			}
		});
	}

	/** get Vehicle **/
	getvehicle() {

		GetData('transport/getvehicle').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					vehic: responseJson
				});
			}
		});
	}

	filterdata() {

		this.state.postFilter = [];
		var rt = [];

		if (this.state.cl.length > 0) {

			this.state.postFilter = this.state.posts.filter(l => {
				return (this.state.cl.indexOf(l.class) != -1);
			});
		}

		if (this.state.se.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.se.indexOf(l.section) != -1);
			});
		}

		if (this.state.com.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.com.indexOf(l.community) != -1);
			});
		}

		if (this.state.rel.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.rel.indexOf(l.religionid) != -1);
			});
		}

		if (this.state.gen.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.gen.indexOf(l.gender) != -1);
			});
		}

		if (this.state.typ.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.typ.indexOf(l.type) != -1);
			});
		}

		if (this.state.tran.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.tran.indexOf(l.route) != -1);
			});
		}

		if (this.state.vehi.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.posts;
			}
			for (var j = 0; j < this.state.route.length; j++) {

				if (this.state.vehi.indexOf(this.state.route[j].vehicleno) != -1) {

					rt.push(this.state.route[j].id);
				}
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (rt.indexOf(l.route) != -1);
			});
		}



		/* if(this.state.stdate!='' && this.state.endate==''){
			console.log(this.state.stdate);
		  for(var i=0; i<this.state.posts.length; i++){
			 if(this.state.posts[i].admissiondate >= this.state.stdate){
			 	
				 this.state.postFilter.push(this.state.posts[i]);
			 }
		  }
		 }
	 	
		 if(this.state.stdate=='' && this.state.endate!=''){
		  for(var i=0; i<this.state.posts.length; i++){
			 if(this.state.posts[i].admissiondate <= this.state.endate){
			 	
				 this.state.postFilter.push(this.state.posts[i]);
			 }
		  }
		 }
	 	
		 if(this.state.stdate!='' && this.state.endate!=''){
		  for(var i=0; i<this.state.posts.length; i++){
			 if(this.state.posts[i].admissiondate >= this.state.stdate && this.state.posts[i].admissiondate <= this.state.endate){
			 	
				 this.state.postFilter.push(this.state.posts[i]);
			 }
		  }
		 } */

		$("#totstud").html(this.state.postFilter.length);
	}

	getdob(dob) {

		var emptydob = '';
		if (dob != '0000-00-00') {
			var ed = new Date(dob);
			var edate = ed.setDate(ed.getDate());

			var d = new Date(edate),
				month = '' + (d.getMonth() + 1),
				day = '' + (d.getDate()),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [day, month, year].join('-');
		}
		else {

			return emptydob;
		}
	}

	render() {

		$("#hide_div").hide();

		var acyear = this.state.accyear;
		// var items = this.state.clas;
		var cas = this.state.caste;
		// var com = this.state.communi;
		var rc = this.state.rcod;

		if (this.state._redirect) {

			return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

		}

		/** get year only select box **/
		const currentYear = new Date().getFullYear();
		const fromMonth = new Date(currentYear - 1, 0);
		const toMonth = new Date(currentYear + 3, 11);

		const years = [];
		for (let i = 2017; i <= currentYear; i += 1) {
			years.push(i);
		}

		/** map Class value to react multi select **/
		var yea = years.map(function (e) {
			return (
				{ value: e, label: e }
			);
		});

		var clss = [];
		clss.push({ value: "all", label: 'All' });
		/** map Class value to react multi select **/
		this.state.clas.map(function (e, key) {
			clss.push(
				{ value: e.id, label: e.class }
			);
		});

		var sec = [];
		sec.push({ value: "all", label: 'All' });
		/** map Section value to react multi select **/
		this.state.sect.map(function (e, key) {
			sec.push(
				{ value: e.id, label: e.section }
			);
		});

		var com = [];
		com.push({ value: "all", label: 'All' });
		/** map Community value to react multi select **/
		this.state.communi.map(function (e, key) {
			com.push(
				{ value: e.id, label: e.community }
			);
		});

		var rel = [];
		rel.push({ value: "all", label: 'All' });
		/** map Religion value to react multi select **/
		this.state.reli.map(function (e, key) {
			rel.push(
				{ value: e.id, label: e.religion }
			);
		});

		var trans = [];
		trans.push({ value: "all", label: 'All' });
		/** map Destination value to react multi select **/
		this.state.route.map(function (e, key) {
			trans.push(
				{ value: e.id, label: e.startplace + ' - ' + e.stopplace }
			);
		});

		var vehi = [];
		vehi.push({ value: "all", label: 'All' });
		/** map Vehicle value to react multi select **/
		this.state.vehic.map(function (e, key) {
			vehi.push(
				{ value: e.id, label: e.regno }
			);
		});

		/** set type select box **/
		this.sttype = [
			{ value: '', name: 'Select' },
			{ value: 'all', name: 'All' },
			{ value: 'rte', name: 'RTE' },
			{ value: 'regular', name: 'Regular' },
			{ value: 'new', name: 'New' }
		];

		/** set gender select box **/
		this.gend = [
			{ value: 'all', name: 'All' },
			{ value: 'Male', name: 'Male' },
			{ value: 'Female', name: 'Female' }
		];

		var gen = [];
		gen.push({ value: 'all', name: 'All' });
		/** map gender value to react multi select **/
		this.gend.map(function (e, key) {
			gen.push(
				{ value: e.value, label: e.name }
			);
		});

		/** map Type value to react multi select **/
		var stype = this.sttype.map(function (e, key) {
			return (
				{ value: e.value, label: e.name }
			);
		});

		if (this.state.viewtab == '1') {

			$("#report").show();
		}
		else {

			$("#report").hide();
		}

		if (this.state.postFilter.length == 0) {

			$("#nodata").show();
		}
		else {

			$("#nodata").hide();
		}

		if (this.state.dob == true) {

			$(".dob").show();
		}
		else {

			$(".dob").hide();
		}
		if (this.state.fname == true) {

			$(".father").show();
		}
		else {

			$(".father").hide();
		}
		if (this.state.mname == true) {

			$(".mother").show();
		}
		else {

			$(".mother").hide();
		}
		if (this.state.cname == true) {

			$(".comm").show();
		}
		else {

			$(".comm").hide();
		}
		if (this.state.caste == true) {

			$(".cas").show();
		}
		else {

			$(".cas").hide();
		}
		if (this.state.addrs == true) {

			$(".addr").show();
		}
		else {

			$(".addr").hide();
		}
		if (this.state.aadhar == true) {

			$(".aadha").show();
		}
		else {

			$(".aadha").hide();
		}
		if (this.state.emis == true) {

			$(".emisno").show();
		}
		else {

			$(".emisno").hide();
		}
		if (this.state.jodate == true) {

			$(".jdate").show();
		}
		else {
			$(".jdate").hide();
		}
		if (this.state.addtecheck == true) {

			$(".addate").show();
		}
		else {

			$(".addate").hide();
		}
		if (this.state.tplace == true) {

			$(".trans").show();
		}
		else {

			$(".trans").hide();
		}
		if (this.state.vehicleno == true) {

			$(".vehic").show();
		}
		else {

			$(".vehic").hide();
		}
		if (this.state.bgcheck == true) {

			$(".bg").show();
		}
		else {

			$(".bg").hide();
		}
		if (this.state.relcheck == true) {

			$(".relg").show();
		}
		else {

			$(".relg").hide();
		}


		if (this.state.citycheck == true) {

			$(".tcity").show();
		}
		else {

			$(".tcity").hide();
		}
		if (this.state.statecheck == true) {

			$(".tstate").show();
		}
		else {

			$(".tstate").hide();
		}
		if (this.state.ctrycheck == true) {

			$(".tctry").show();
		}
		else {

			$(".tctry").hide();
		}

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Report</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
										<option value="">Select Academic Year</option>
										{
											acyear.map(function (item) {
												return <option value={item.id}>{item.value}</option>;
											})
										}
									</select>
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="3">
											<Label>Class</Label>
											<Select value={this.state.classs} id="classs" onChange={this.handleClassChange} multi options={clss} />
										</Col>
										<Col md="3">
											<Label>Section</Label>
											<Select value={this.state.section} id="section" onChange={this.handleSecChange} multi options={sec} />
										</Col>
										<Col md="3">
											<Label>Community</Label>
											<Select value={this.state.community} id="communi" onChange={this.handleCommuniChange} multi options={com} />
										</Col>
										<Col md="3">
											<Label>Religion</Label>
											<Select value={this.state.religion} id="reli" onChange={this.handleRelChange} multi options={rel} />
										</Col>
										<Col md="3">
											<FormGroup>
												<Label htmlFor="name">Route </Label>
												<Select value={this.state.transport} id="trans" onChange={this.handleTransChange} multi options={trans} />
											</FormGroup>
										</Col>
										<Col md="3">
											<FormGroup>
												<Label htmlFor="name">Vehicle </Label>
												<Select value={this.state.vehicle} id="vehi" onChange={this.handleVehicleChange} multi options={vehi} />
											</FormGroup>
										</Col>
										<Col md="3">
											<FormGroup>
												<Label htmlFor="name">Gender </Label>
												<Select value={this.state.gender} id="gen" onChange={this.handleGenderChange} multi options={gen} />
											</FormGroup>
										</Col>
										<Col md="3">
											<FormGroup>
												<Label htmlFor="name">Type </Label>
												<Select value={this.state.type} id="type" onChange={this.handleTypeChange} multi options={stype} />
											</FormGroup>
										</Col>


										<Col md="1">
											<FormGroup>
												<Label htmlFor="name"></Label>
												<Button color="primary" className="btn-right" disabled={this.state.posts.length > 0 ? false : true} id="btn-repview" onClick={this.onViewClick}>{this.state.posts.length > 0 ? 'View' : 'Loading...'}</Button>
											</FormGroup>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row id="report">
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Student Report -  &nbsp;<Badge color="danger"><span id="totstud"></span></Badge></strong>
									<Workbook filename="example.xlsx" element={<button className="btn-sm btn-right btn-success" ><i className="fa fa-file-excel-o"></i>  Excel Export</button>}>
										<Workbook.Sheet data={this.state.postFilter} name="Sheet A">
											<Workbook.Column label="Regno" value="regno" />
											<Workbook.Column label="Join Date" value="joindate" />
											<Workbook.Column label="Admission Date" value="admissiondate" />
											<Workbook.Column label="Name" value="stdname" />
											<Workbook.Column label="DOB" value="dob" />
											<Workbook.Column label="Gender" value="gender" />
											<Workbook.Column label="Class" value="cls" />
											<Workbook.Column label="Section" value="sec" />
											<Workbook.Column label="Aadhar No" value="aadharno" />
											<Workbook.Column label="EMIS No" value="emisno" />
											<Workbook.Column label="Father Name" value="fathername" />
											<Workbook.Column label="Mother Name" value="mothername" />
											<Workbook.Column label="Address" value="presentaddr" />
											<Workbook.Column label="Email" value="email" />
											<Workbook.Column label="Mobile" value="mobile" />
											<Workbook.Column label="Community" value="communi" />
											<Workbook.Column label="Caste" value="cast" />
											<Workbook.Column label="Transport Place" value="transplace" />
											<Workbook.Column label="Vehicle" value="vehi" />
											<Workbook.Column label="Religion" value="religion" />
											<Workbook.Column label="Blood Group" value="bloodgroup" />
											<Workbook.Column label="City" value="city" />
											<Workbook.Column label="State" value="state" />
											<Workbook.Column label="Country" value="country" />
										</Workbook.Sheet>
									</Workbook>
									<Button size="sm" className="btn-right" color="warning" onClick={this.printDocument}><i className="fa fa-print"></i> Print</Button>
									<ButtonGroup className="btn-right">
										<ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
											<DropdownToggle caret color="info" className="btn-sm">
												Fields
								</DropdownToggle>
											<DropdownMenu>
												<DropdownItem><input type="checkbox" name="dob" checked={this.state.dob} onChange={this.onAddFields.bind(this)} />&nbsp;DOB</DropdownItem>
												<DropdownItem><input type="checkbox" name="aadhar" checked={this.state.aadhar} onChange={this.onAddFields.bind(this)} />&nbsp;Aadhar No</DropdownItem>
												<DropdownItem><input type="checkbox" name="emis" checked={this.state.emis} onChange={this.onAddFields.bind(this)} />&nbsp;EMIS No</DropdownItem>
												<DropdownItem><input type="checkbox" name="jodate" checked={this.state.jodate} onChange={this.onAddFields.bind(this)} />&nbsp;Join Date</DropdownItem>
												<DropdownItem><input type="checkbox" name="addtecheck" checked={this.state.addtecheck} onChange={this.onAddFields.bind(this)} />&nbsp;Admission Date</DropdownItem>
												<DropdownItem><input type="checkbox" name="fname" checked={this.state.fname} onChange={this.onAddFields.bind(this)} />&nbsp;FName</DropdownItem>
												<DropdownItem><input type="checkbox" name="mname" checked={this.state.mname} onChange={this.onAddFields.bind(this)} />&nbsp;MName</DropdownItem>
												<DropdownItem><input type="checkbox" name="addrs" checked={this.state.addrs} onChange={this.onAddFields.bind(this)} />&nbsp;Address</DropdownItem>
												<DropdownItem><input type="checkbox" name="cname" checked={this.state.cname} onChange={this.onAddFields.bind(this)} />&nbsp;Community</DropdownItem>
												<DropdownItem><input type="checkbox" name="caste" checked={this.state.caste} onChange={this.onAddFields.bind(this)} />&nbsp;Caste</DropdownItem>
												<DropdownItem><input type="checkbox" name="tplace" checked={this.state.tplace} onChange={this.onAddFields.bind(this)} />&nbsp;Transport Place</DropdownItem>
												<DropdownItem><input type="checkbox" name="bgcheck" checked={this.state.bgcheck} onChange={this.onAddFields.bind(this)} />&nbsp;Blood Group</DropdownItem>
												<DropdownItem><input type="checkbox" name="relcheck" checked={this.state.relcheck} onChange={this.onAddFields.bind(this)} />&nbsp;Religion</DropdownItem>
												<DropdownItem><input type="checkbox" name="citycheck" checked={this.state.citycheck} onChange={this.onAddFields.bind(this)} />&nbsp;City</DropdownItem>
												<DropdownItem><input type="checkbox" name="statecheck" checked={this.state.statecheck} onChange={this.onAddFields.bind(this)} />&nbsp;State</DropdownItem>
												<DropdownItem><input type="checkbox" name="ctrycheck" checked={this.state.ctrycheck} onChange={this.onAddFields.bind(this)} />&nbsp;Country</DropdownItem>
											</DropdownMenu>
										</ButtonDropdown>
									</ButtonGroup>
								</CardHeader>
								<CardBody id="print-report">
									<Row>
										<table id="hide_div">
											<tbody>
												<tr>
													<td rowSpan="4" width="170" align="right" style={{ paddingLeft: '90px', paddingRight: '10px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
												</tr>
												<tr>
													<td align="center" className="ctext">{GLOBAL.Sclful_NAME}</td>
												</tr>
												<tr>
													<td align="center" className="caddrtext">{GLOBAL.Scl_Addr}</td>
												</tr>
												<tr>
													<td align="center" className="caddrtext">{GLOBAL.Scl_Dist}</td>
												</tr>
											</tbody>
										</table>
										<br />
										<Col md="12">
											<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%">
												<thead>
													<tr>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>S.No</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Reg No</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="jdate">Join Date</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="addate">Admission Date</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Student Name</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="dob">DOB</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Gender</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Class</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Section</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Mobile</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="father">Father Name</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="mother">Mother Name</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="addr">Address</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="aadha">Aadhar No</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="emisno">EMIS No</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="comm">Community</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="cas">Caste</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="trans">Transport Place</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="vehic">Vehicle</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="bg">Blood Group</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="relg">Religion</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="tcity">City</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="tstate">State</th>
														<th style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="tctry">Country</th>
													</tr>
												</thead>
												<tbody>
													{this.state.postFilter.map((item, index) =>

														<tr key={item}>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{index + 1}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{item.regno}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="jdate">{this.getdob(item.joindate)}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="addate">{this.getdob(item.admissiondate)}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{item.stdname}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="dob">{this.getdob(item.dob)}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{item.gender}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{item.cls}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{item.sec}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>{item.mobile}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="father">{item.fathername}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="mother">{item.mothername}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="addr">{item.presentaddr}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="aadha">{item.aadharno}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="emisno">{item.emisno}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="comm">{item.communi}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="cas">{item.cast}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="trans">{item.transplace}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="vehic">{item.vehi}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="bg">{item.bloodgroup}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="relg">{item.religion}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="tcity">{item.city}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="tstate">{item.state}</td>
															<td style={{ border: '1px solid black', borderCollapse: 'collapse' }} className="tctry">{item.country}</td>
														</tr>
													)}
												</tbody>
												<tbody id="nodata">
													<tr><td style={{ border: '1px solid black' }} colSpan="7" align="center"><span id="datanotfound">Data not found...</span></td></tr>
												</tbody>
											</Table>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default StudentReport;


// WEBPACK FOOTER //
// ./src/student/Report/StudentReport.js